import {
  LayoutDashboard, Users, UserCircle, Calendar, DollarSign, CreditCard, Settings,
  Stethoscope, Wallet, Activity, FileDown, FileText, Link2, Briefcase, Megaphone, ShieldCheck, Building2,
} from 'lucide-react';

export const ALL_ROLES = ['super_admin', 'finance_admin', 'pre_sales', 'sales', 'operations', 'doctor', 'marketing'];

// Single source of truth for sidebar AND route guards.
export const NAV_SECTIONS = [
  {
    id: 'dashboards', label: 'Dashboards', icon: LayoutDashboard, defaultOpen: true,
    items: [
      { name: 'Overall Dashboard', href: '/dashboard', roles: ['super_admin', 'finance_admin', 'operations'] },
      { name: 'Pre-Sales Dashboard', href: '/presales-dashboard', roles: ['super_admin', 'finance_admin', 'pre_sales'] },
      { name: 'Sales Dashboard', href: '/sales-dashboard', roles: ['super_admin', 'finance_admin', 'sales'] },
      { name: 'Marketing Stats', href: '/marketing', roles: ['super_admin', 'marketing'] },
    ],
  },
  {
    id: 'operations', label: 'Operations', icon: Briefcase, defaultOpen: true,
    items: [
      { name: 'Leads', href: '/leads', icon: Users, roles: ['super_admin', 'pre_sales', 'sales', 'operations', 'marketing'] },
      { name: 'Calendar', href: '/calendar', icon: Calendar, roles: ['super_admin', 'pre_sales', 'sales'] },
      { name: 'Batches', href: '/trial-slots', icon: Calendar, roles: ['super_admin'] },
      { name: 'Payments', href: '/payments', icon: CreditCard, roles: ['super_admin', 'finance_admin', 'sales', 'pre_sales'] },
      { name: 'Doctors', href: '/doctors', icon: Stethoscope, roles: ['super_admin', 'finance_admin'] },
      { name: 'Commissions', href: '/commissions', icon: Wallet, roles: ['super_admin', 'finance_admin'] },
      { name: 'Export', href: '/export', icon: FileDown, roles: ['super_admin', 'finance_admin'] },
      { name: 'Audit Log', href: '/audit-log', icon: Activity, roles: ['super_admin', 'finance_admin'] },
    ],
  },
  {
    id: 'marketing', label: 'Marketing', icon: Megaphone, defaultOpen: false,
    items: [
      { name: 'Pricing', href: '/pricing', icon: DollarSign, roles: ['super_admin'] },
      { name: 'Blog Posts', href: '/blog/posts', icon: FileText, roles: ['super_admin', 'marketing'] },
      { name: 'Blog Authors', href: '/blog/authors', icon: UserCircle, roles: ['super_admin', 'marketing'] },
      { name: 'Blog Config', href: '/blog/config', icon: Settings, roles: ['super_admin', 'marketing'] },
      { name: 'Corporate Enquiries', href: '/corporate-enquiries', icon: Building2, roles: ['super_admin'] },
    ],
  },
  {
    id: 'payroll', label: 'Payroll', icon: Wallet, defaultOpen: false,
    items: [
      { name: 'Payslips', href: '/payslips', icon: FileText, roles: ALL_ROLES },
    ],
  },
  {
    id: 'admin', label: 'Admin', icon: ShieldCheck, defaultOpen: false,
    items: [
      { name: 'Users', href: '/users', icon: UserCircle, roles: ['super_admin'] },
      { name: 'Settings', href: '/settings', icon: Settings, roles: ['super_admin'] },
      { name: 'LMS Integration', href: '/lms-integration', icon: Link2, roles: ['super_admin', 'finance_admin'] },
      { name: 'Integration Health', href: '/integration-health', icon: Activity, roles: ['super_admin', 'finance_admin'] },
      { name: 'Data Integrity', href: '/data-integrity', icon: ShieldCheck, roles: ['super_admin', 'finance_admin'] },
    ],
  },
];

// Routes not in the sidebar but still gated.
const EXTRA_ROUTE_ROLES = {
  '/marketing-intel': ['super_admin', 'marketing'],
  '/blog/posts/:slug': ['super_admin', 'marketing'],
};

export const ROUTE_ROLES = NAV_SECTIONS.reduce((acc, s) => {
  s.items.forEach((it) => { acc[it.href] = it.roles; });
  return { ...acc, ...EXTRA_ROUTE_ROLES };
}, {});

export const canAccess = (path, role) => {
  const roles = ROUTE_ROLES[path];
  return !roles || roles.includes(role);
};

// First route a role is allowed to land on.
export const homeFor = (role) => (canAccess('/dashboard', role) ? '/dashboard' : (
  Object.keys(ROUTE_ROLES).find((p) => canAccess(p, role)) || '/dashboard'
));
